function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.638,42.487c-3.054,3.803 -7.742,6.237 -13.002,6.237c-9.209,-0 -16.667,-7.458 -16.667,-16.667c-0,-9.208 7.458,-16.666 16.667,-16.666c9.208,-0 16.666,7.458 16.666,16.666c0,2.564 -0.578,4.993 -1.611,7.162c-1.181,0.335 -2.053,1.426 -2.053,2.71l0,0.558Zm-0.189,40.145l-42.17,-0c-2.291,-0 -4.166,-1.875 -4.166,-4.167l0.189,-4.741c0,-11.083 22.209,-16.667 33.334,-16.667c0.932,0 1.942,0.039 3.01,0.118c-0.807,1.295 -1.272,2.826 -1.272,4.468l-0,11.265c-0,3.097 2.345,6.207 5.442,6.207l5.633,-0l-0,3.517Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.161,53.194l-37.916,0c-4.496,0 -8.125,3.774 -8.125,8.449l-0,11.265c-0,3.097 2.437,5.632 5.416,5.632l5.417,-0l0,5.632c0,3.098 2.438,5.633 5.417,5.633l21.666,-0c2.98,-0 5.417,-2.535 5.417,-5.633l0,-5.632l5.417,-0c2.979,-0 5.416,-2.535 5.416,-5.632l0,-11.265c0,-4.675 -3.629,-8.449 -8.125,-8.449Zm-10.833,30.978l-16.25,0c-1.489,0 -2.708,-1.267 -2.708,-2.816l-0,-11.265l21.666,0l0,11.265c0,1.549 -1.218,2.816 -2.708,2.816Zm10.833,-19.713c-1.489,-0 -2.708,-1.267 -2.708,-2.816c0,-1.549 1.219,-2.816 2.708,-2.816c1.49,-0 2.709,1.267 2.709,2.816c-0,1.549 -1.219,2.816 -2.709,2.816Zm-5.416,-25.346l-27.084,0c-1.489,0 -2.708,1.267 -2.708,2.816l0,5.633c0,1.549 1.219,2.816 2.708,2.816l27.084,-0c1.489,-0 2.708,-1.267 2.708,-2.816l0,-5.633c0,-1.549 -1.219,-2.816 -2.708,-2.816Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintUser);
export default __webpack_public_path__ + "static/media/printUser.bdd6b854f487490f06256ac6cc69932c.svg";
export { ForwardRef as ReactComponent };